import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { EditorModule } from 'primeng/editor';

export type ShipmentNotesCommand = { type: 'save'; remarksHtml: string };

/** Editable note surface; persistence is deliberately kept in the shipment route shell. */
@Component({
    selector: 'app-shipment-notes-panel',
    standalone: true,
    templateUrl: './shipment-notes-panel.component.html',
    styleUrls: ['./shipment-notes-panel.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ButtonModule, EditorModule]
})
export class ShipmentNotesPanelComponent {
    readonly remarksHtml = input('');
    readonly saving = input(false);
    readonly readonly = input(false);
    readonly remarksChanged = output<string>();
    readonly command = output<ShipmentNotesCommand>();
}
